import React, { FC, useState } from 'react'
import { SubQuestionProps } from '../../types'
import { DataDrivenSubQuestion } from '../../../../../types'
import { useSubQuestionLogic } from '../../hook/use-sub-question-logic'
import { DatasetQuestionSectionWithRelevantQuestion } from './dataset-question-section-with-relevant-question'
import { DatasetQuestionSectionWithoutRelevantQuestion } from './dataset-question-section-without-relevant-question'
import { DatasetQuestion } from '../../trained_questions/dataset-question'
import { Queries } from '../../queries'
import TabTile from '../../../../../../../../data/components/TabTile'

export const DatasetSubQuestionElement: FC<SubQuestionProps> = ({
  index,
  subQuestion,
  createNewQuestionCallback,
  feedbackId,
  setSolvedCallback,
  modifyQuestions
}) => {
  const dataDrivenSubQuestion = subQuestion as DataDrivenSubQuestion
  const [textWasChanged, setTextWasChanged] = useState<boolean>(false)

  const {
    expanded,
    trainedQuestionExpanded,
    questionCreated,
    trainedQuestions,
    handleToggleExpand,
    handleTrainingQuestionToggleExpand,
    handleCreationNewQuestion,
    deleteTrainedQuestion,
    updateQuestion,
  } = useSubQuestionLogic({
    subQuestionId: subQuestion.subQuestionId,
    feedbackId,
    initialTrainedQuestions: subQuestion.trainedQuestions,
    createNewQuestionCallback,
    setSolvedCallback,
    modifyQuestions,
  })

  const getColor = (): string | undefined => {
    if (questionCreated) return 'rgba(144, 238, 144, 0.8)'
    if (textWasChanged) return 'rgba(255, 140, 0, 0.6)'
    return undefined
  }

  const renderDatasetSection = () => {
    if (subQuestion.mostRelevantQuestion) {
      return (
        <DatasetQuestionSectionWithRelevantQuestion
          question={subQuestion.task}
          answer={dataDrivenSubQuestion.queries?.[0]?.query || ''}
          onCreateNewQuestion={(question, answer, questionType) => {
            handleCreationNewQuestion(question, answer, questionType)
          }}
          onUpdate={updateQuestion}
          mostRelevantQuestion={subQuestion.mostRelevantQuestion}
          onTextWasChanged={setTextWasChanged}
          initQuestionType={subQuestion.mostRelevantQuestion.questionType}
        />
      )
    } else {
      return (
        <DatasetQuestionSectionWithoutRelevantQuestion
          question={subQuestion.task}
          answer={dataDrivenSubQuestion.queries?.[0]?.query || ''}
          onCreateNewQuestion={(question, answer) => {
            handleCreationNewQuestion(question, answer, dataDrivenSubQuestion.datasetName)
          }}
        />
      )
    }
  }

  return (
    <TabTile
      shadowColor={getColor()}
      tab={{
        name: (
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'inline-block',
              maxWidth: '100%',
            }}>{`${index}. ${dataDrivenSubQuestion.datasetName}: ${dataDrivenSubQuestion.task}`}</span>
        ),
      }}
      expanded={expanded}
      onChange={handleToggleExpand}>
      {renderDatasetSection()}

      {trainedQuestions && trainedQuestions.length > 0 && (
        <TabTile
          tab={{ name: <span>New Trained Questions</span> }}
          expanded={trainedQuestionExpanded}
          onChange={handleTrainingQuestionToggleExpand}>
          {trainedQuestions.map((q, idx) => (
            <div
              key={q.trainingQuestionId || idx}
              style={{
                padding: '16px',
                borderRadius: '8px',
                background: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                marginBottom: '1rem',
              }}>
              <DatasetQuestion
                question={q.question}
                answer={q.answer}
                deleteTrainingQuestionCallback={deleteTrainedQuestion}
                updateQuestionCallback={updateQuestion}
                questionType="trained"
                questionId={q.trainingQuestionId}
                initQuestionType={q.questionType}
              />
            </div>
          ))}
        </TabTile>
      )}
      <Queries queries={dataDrivenSubQuestion.queries} />
    </TabTile>
  )
}
